<template>
    <div>
        <div class="form-group">
            <label>URL</label>
            <input type="text" class="form-control" v-model="data.url">
        </div>
        <div class="form-group">
            <label>Client ID</label>
            <input type="text" class="form-control" v-model="data.client_id">
        </div>
        <div class="form-group">
            <label>API Secret</label>
            <input type="text" class="form-control" v-model="data.api_secret">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data'
    ],
    data() {
        return {};
    }
}
</script>
